import { Route } from '@angular/router';

import { UserRouteAccessService } from '../shared';
import { DepotRequeteComponent } from './depot-requete.component';
import { depotRequeteBasePath, depotRequeteSteps } from './depot-requete.data';
import { DraftRequeteResolver } from './draft-requete.resolver';
import { LoadDraftComponent } from './load-draft.component';
import {
  AvertissementComponent, JuridictionComponent, RequeteComponent, JustificatifsComponent, RecapitulatifComponent, RequerantsComponent
} from './steps';

export const DEPOT_REQUETE_ROUTE: Route = {
    path: depotRequeteBasePath,
    component: DepotRequeteComponent,
    resolve: {
        draftRequete: DraftRequeteResolver
    },
    children: [
        {
            path: '',
            component: LoadDraftComponent,
            pathMatch: 'full',
            data: {
                needAuthentication: true
            },
            canActivate: [UserRouteAccessService]
        },
        {
            path: depotRequeteSteps[0].route,
            component: AvertissementComponent,
            data: {
                needAuthentication: true,
                pageTitle: depotRequeteSteps[0].pageTitle
            },
            canActivate: [UserRouteAccessService]
        },
        {
            path: depotRequeteSteps[1].route,
            component: RequerantsComponent,
            data: {
                needAuthentication: true,
                pageTitle: depotRequeteSteps[1].pageTitle
            },
            canActivate: [UserRouteAccessService]
        },
        {
            path: depotRequeteSteps[2].route,
            component: JuridictionComponent,
            data: {
                needAuthentication: true,
                pageTitle: depotRequeteSteps[2].pageTitle
            },
            canActivate: [UserRouteAccessService]
        },
        {
            path: depotRequeteSteps[3].route,
            component: RequeteComponent,
            data: {
                needAuthentication: true,
                pageTitle: depotRequeteSteps[3].pageTitle
            },
            canActivate: [UserRouteAccessService]
        },
        {
            path: depotRequeteSteps[4].route,
            component: JustificatifsComponent,
            data: {
                needAuthentication: true,
                pageTitle: depotRequeteSteps[4].pageTitle
            },
            canActivate: [UserRouteAccessService]
        },
        {
            path: depotRequeteSteps[5].route,
            component: RecapitulatifComponent,
            data: {
                needAuthentication: true,
                pageTitle: depotRequeteSteps[5].pageTitle
            },
            canActivate: [UserRouteAccessService]
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/depot-requete/depot-requete.route.ts